module.exports = __webpack_public_path__ + "static/media/vaaralliset-min.31ff752b.jpg";